import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, useResponsive } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';
import SaveAsDefaultCheckbox from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/SaveAsDefaultCheckbox';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';

interface Props {
  onClose: () => void;
  onSave?: (id?: string) => void;
  updateDefaultPaymentMethod: (paymentMethodId: number) => void;
  isRefund?: boolean;
}

const ChoosePaymentMethodFooter: React.FC<Props> = ({ onClose, onSave, updateDefaultPaymentMethod, isRefund }) => {
  const { isMobile } = useResponsive();
  const [isSaveAsDefault, setIsSaveAsDefault] = useState(false);
  const selectedMethod = useStore((state) => state.selectedMethod);
  const handleSetActivePaymentMethod = useStore((state) => state.handleSetActivePaymentMethod);

  const { t } = useTranslation();

  const handleSavePaymentMethod = useCallback(() => {
    handleSetActivePaymentMethod();
    if (selectedMethod && isSaveAsDefault) {
      updateDefaultPaymentMethod(Number(selectedMethod.id));
    }
    onClose();
    if (onSave) onSave(selectedMethod?.id);
  }, [
    handleSetActivePaymentMethod,
    onClose,
    selectedMethod,
    updateDefaultPaymentMethod,
    isSaveAsDefault,
    onSave,
  ]);

  return (
    <Box
      direction={isMobile ? 'column' : 'row'}
      justify="between"
      margin={{ top: 'spacing24', horizontal: 'spacing12' }}
    >
      {isRefund ? <Box /> : (
        <SaveAsDefaultCheckbox
          isSaveAsDefault={isSaveAsDefault}
          setIsSaveAsDefault={setIsSaveAsDefault}
          isDisabled={!selectedMethod}
        />
      )}

      <AppButton fill={isMobile} width={isMobile ? undefined : '130px'} onClick={handleSavePaymentMethod}>
        {t('Save')}
      </AppButton>
    </Box>
  );
};

export default ChoosePaymentMethodFooter;
